// === library ===
import React, { useEffect, useReducer, useRef, useState } from "react";
import {
  Platform,
  Image,
  View,
  TouchableWithoutFeedback,
  Dimensions,
} from "react-native";
import {
  Center,
  Icon,
  KeyboardAvoidingView,
  useToast,
  VStack,
} from "native-base";
import { useDispatch, useSelector } from "react-redux";
import { translate } from "../../locales/translate";
import * as faCharCodes from "../../../assets/consts/faCharCodes";
import * as AppActions from "../../actions/AppActions";
import * as CONSTS from "../../../assets/consts";
// === Components ===
import FontAwesomeIcon from "../../components_v2/FontAwesomeIcon";
import InputBase from "../../nativeBase-ui/InputBase";
import ToastAlert from "../../nativeBase-ui/ToastAlert";
import CountDown from "../../components/CountDown";
import { ArButton } from "../../argon-ui";
import * as SecureStore from "../../components_v2/DeviceAsyncStorage";
// === Modules ===
import DeviceInfoHandler from "../../modules/deviceInfo/DeviceInfoHandler";
import Theme from "../../argon-ui/Theme";
import LoginLayout from "./LoginLayout";
import buildingsInfoGenerate from "../../hooks/buildingsInfoGenerate";
import BuildingInfo from "../../viewModels/BuildingInfo";
import TextFont from "../../components_v2/TextFont";
import { persianToEnglishNumber, validationPassword } from "../../util";
import ServerInfo from "../../viewModels/ServerInfo";
import CaptchaCode from "../../components_v2/CaptchaCode";
const LOGO_SIZE = 150;
const INPUT_HEIGHT = 50;
interface Props {
  navigation: any;
}
export type FormStatePhoneNumber = {
  phoneNumber: string;
  captchaCode: string | null;
};
type FormStateReset = {
  otp: string;
  password: string;
  confirmPassword: string;
  captchaCode: string;
};
const initialState: FormStatePhoneNumber = {
  phoneNumber: "",
  captchaCode: null,
};
const initialStateReset: FormStateReset = {
  otp: "",
  password: "",
  confirmPassword: "",
  captchaCode: "",
};
type FormValidityState = {
  phoneNumberError: boolean;
  phoneNumberErrorMessage: string;
  captchaCodeError: boolean;
  captchaCodeErrorMessage: string;
  isFormValid: boolean;
};
type FormResetValidityState = {
  otpError: boolean;
  otpErrorMessage: string;
  passwordError: boolean;
  passwordErrorMessage: string;
  confirmPasswordError: boolean;
  confirmPasswordErrorMessage: string;
  captchaCodeError: boolean;
  captchaCodeErrorMessage: string;
  isFormValid: boolean;
};
const initialValidityStateReset: FormResetValidityState = {
  otpError: false,
  otpErrorMessage: "",
  passwordError: false,
  passwordErrorMessage: "",
  confirmPasswordError: false,
  confirmPasswordErrorMessage: "",
  captchaCodeError: false,
  captchaCodeErrorMessage: "",
  isFormValid: false,
};
const initialValidityState: FormValidityState = {
  phoneNumberError: false,
  phoneNumberErrorMessage: "",
  captchaCodeError: false,
  captchaCodeErrorMessage: "",
  isFormValid: false,
};
type FormAction = {
  type: string;
  payLoad: string;
};
type FormValidityAction = {
  type: string;
  payLoad: FormStatePhoneNumber;
};
type FormValidityActionReset = {
  type: string;
  payLoad: FormStateReset;
};

const ResetPasswordScreen = (props: Props) => {
  const dispatch = useDispatch();
  const appReducer = useSelector((state: any) => state.AppReducer);
  let { navigation } = props;
  const toast = useToast();
  const captchaCodeRef = useRef<any>(null);
  const [serverUrl, setServerUrl] = useState(appReducer.serverUrl);
  const [showOtpLayout, setShowOtpLayout] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [resetPasswordTimeLeft, setResetPasswordTimeLeft] = useState(0);
  const [errors, setErrors] = useState<any>([]);
  const [loading, setLoading] = useState(false);

  const ToastDetails = [
    {
      title: translate("login.successResetPassword"),
      variant: "subtle",
      status: "success",
    },
    {
      title: translate("login.errors.FailedToUpdateAccount"),
      variant: "subtle",
      status: "error",
    },
    {
      title: translate("login.errors.InvalidResetToken"),
      variant: "subtle",
      status: "error",
    },
    {
      title: translate("login.errors.undefinedError"),
      variant: "subtle",
      status: "error",
    },
    {
      title: translate("login.errors.InvalidPhoneNumber"),
      variant: "subtle",
      status: "error",
    },
  ];
  // === Kiosk Mode ===
  const [isKioskMode, setIsKioskMode] = useState(false);

  // === Kiosk Mode handler  ===
  const KioskMode = () => {
    var devInfo = new DeviceInfoHandler();
    let isKioskModeDevice: boolean = devInfo.isKioskMode();
    setIsKioskMode(isKioskModeDevice);
    dispatch(AppActions.updateKioskMode(isKioskModeDevice));
  };
  // === first Load ===
  useEffect(() => {
    KioskMode();
  }, []);
  // === update Kiosk with change width size ===
  useEffect(() => {
    Dimensions.addEventListener("change", () => KioskMode());

    return () => {
      Dimensions.removeEventListener("change", () => KioskMode());
    };
  }, []);
  const generateMessageToast = (errorMessage: string, status = "error") => {
    const toastMessage = {
      title: translate(`login.errors.${errorMessage}`),
      variant: "subtle",
      status,
    };
    toast.show({
      render: () => {
        return <ToastAlert {...toastMessage} />;
      },
    });
  };
  //   === Sign In Handler ===
  const requestOTP = (
    values: FormStatePhoneNumber,
    captchaId: string,
    setFormData?: any
  ) => {
    const { captchaCode, phoneNumber } = values;
    setLoading(true);
    setPhoneNumber(phoneNumber);
    const UserName = persianToEnglishNumber(phoneNumber);
    let _serverUrl = serverUrl;
    if (!_serverUrl.endsWith("/")) {
      _serverUrl += "/";
    }
    if (_serverUrl) {
      fetch(`${_serverUrl}Auth/ResetPasswordToken`, {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          UserName,
          captchaCode,
          captchaId,
        }),
      })
        .then((res) => {
          return res.json();
        })
        .then((resj) => {
          setLoading(false);
          if (resj.otpSent) {
            if (resj.timeLeft && Number(resj.timeLeft)) {
              setShowOtpLayout(true);
              setResetPasswordTimeLeft(resj.timeLeft);
              setFormData &&
                setFormData({
                  type: "UPDATE_PHONE_NUMBER",
                  payLoad: "",
                });
              setFormData &&
                setFormData({
                  type: "UPDATE_CAPTCHA_CODE",
                  payLoad: "",
                });
            }
          } else {
            resj.errors.map((error: string) => {
              generateMessageToast(error);
            });
            setLoading(false);
            setErrors(resj.errors);
            captchaCodeRef && captchaCodeRef?.current?.refreshCaptcha();
          }
        })
        .catch((err) => {
          setLoading(false);
          captchaCodeRef && captchaCodeRef?.current?.refreshCaptcha();
          generateMessageToast("undefinedError");
          console.log("error change password", err);
        });
    }
  };
  const resetPasswordHandler = (
    values: FormStateReset,
    setFormData: any,
    captchaId: string
  ) => {
    setLoading(true);
    let _serverUrl = serverUrl;
    if (!_serverUrl.endsWith("/")) {
      _serverUrl += "/";
    }
    if (_serverUrl) {
      fetch(`${_serverUrl}Auth/ResetPassword`, {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          UserName: phoneNumber,
          NewPassword: values.password,
          ConfirmPassword: values.confirmPassword,
          OTP: values.otp,
          captchaCode: values.captchaCode,
          captchaId,
        }),
      })
        .then((res) => {
          return res.json();
        })
        .then((resj) => {
          const {
            access_token,
            userFullName,
            userId,
            buildings,
            serverId,
            cloudServerId,
            authenticated,
            errors,
          } = resj;

          if (authenticated) {
            setLoading(false);
            toast.show({
              render: () => {
                return <ToastAlert {...ToastDetails[0]} />;
              },
            });
            setTimeout(() => {
              handleOnLogin(
                serverUrl,
                serverId,
                cloudServerId,
                access_token,
                userFullName,
                userId,
                buildings,
                setFormData
              );
            }, 1000);
          } else {
            setLoading(false);
            if (errors) {
              console.log(errors);
              {
                errors.length !== 0 &&
                  errors.map((e: string) => {
                    generateMessageToast(e);
                  });
              }
              if (!Array.isArray(resj.errors)) {
                var serverAuthErrors = [resj.errors];
                setErrors(serverAuthErrors);
              }
            } else {
              setLoading(false);
              generateMessageToast("undefinedError");
              setErrors(["Unknown"]);
            }
          }
        })
        .catch((err) => {
          generateMessageToast("undefinedError");
          setLoading(false);
          console.log(err);
        });
    }
  };
  const forceInitHandler = async (accessToken: string, building = null) => {
    const currentServer = await SecureStore.Servers.getCurrentServer();
    dispatch(AppActions.updateCurrentServer(currentServer));
    dispatch(AppActions.ForceInit(accessToken, building));
  };
  const handleOnLogin = async (
    serverUrl: string,
    serverId: string,
    cloudServerId: string | null,
    token: string,
    userFullName: string,
    userId: string,
    buildings: any = [],
    setFormData?: any
  ) => {
    let publicAddress = null;
    let localAddress = null;
    if (cloudServerId) {
      const servers = await SecureStore.Servers.getServers();
      if (servers && servers.length !== 0) {
        const findServer = servers.find(
          (server: ServerInfo) => server.serverId === cloudServerId
        );
        if (findServer) {
          publicAddress = findServer.publicAddress;
        }
      } else {
        publicAddress = serverUrl;
      }
      localAddress = serverUrl;
    } else {
      publicAddress = serverUrl;
    }
    SecureStore.Servers.addServer({
      serverId: serverId || buildings[0]?.serverId,
      publicAddress,
      localAddress,
      accessToken: token,
      userFullName,
      userId,
      ports: CONSTS.DEFAULT_PORTS_BRAND,
    });
    SecureStore.setItemAsync(CONSTS.USER_ID, userId);
    SecureStore.setItemAsync(CONSTS.ACCESS_TOKEN, token);
    if (buildings.length !== 0) {
      const buildingsInfo = buildingsInfoGenerate(buildings);
      onProfileSelect(buildingsInfo[0], token);
      forceInitHandler(token, buildingsInfo[0].buildingId);
      dispatch(AppActions.setBuildings(buildingsInfo));
      navigation.replace("Home");
    } else {
      forceInitHandler(token);
      navigation.replace("Home");
    }
    setFormData({
      type: "UPDATE_OTP",
      payLoad: "",
    });
    setFormData({
      type: "UPDATE_PASSWORD",
      payLoad: "",
    });
    setFormData({
      type: "UPDATE_CONFIG_PASSWORD",
      payLoad: "",
    });
  };
  const onProfileSelect = async (
    profile: BuildingInfo,
    accessToken?: string
  ) => {
    const { navigation } = props;
    dispatch(AppActions.updateCurrentBuilding(profile));

    SecureStore.setItemAsync(CONSTS.ACCESS_TOKEN, accessToken);
    SecureStore.setAccessToken(profile.buildingId, accessToken);

    const currentServer = await SecureStore.Servers.getCurrentServer();
    dispatch(AppActions.updateCurrentServer(currentServer));

    dispatch(AppActions.ForceInit(accessToken, profile.buildingId));
    navigation.replace("Home");
  };
  return (
    <LoginLayout>
      <KeyboardAvoidingView
        justifyContent="center"
        w={isKioskMode ? "50%" : "100%"}
        h="100%"
        behavior={Platform.OS === "ios" ? "padding" : "height"}
      >
        <Center w="100%">
          <Center w="100%">
            {!isKioskMode && (
              <Image
                source={CONSTS?.BRANDING?.LOGO_TYPE}
                // width={LOGO_SIZE}
                // height={LOGO_SIZE}
                // style={styles.logo}
                style={{
                  width: LOGO_SIZE,
                  height: 50,
                  resizeMode: "contain",
                }}
              />
            )}
          </Center>
          <View
            style={{
              paddingVertical: 5,
              marginBottom: 10,
              width: "90%",
              maxWidth: isKioskMode ? "100%" : "90%",
            }}
          >
            <TextFont
              style={{
                fontSize: 18,
                fontWeight: "600",
                color: Theme.COLORS.MUTED,
              }}
            >
              {translate("login.goToResetPassword")}
            </TextFont>
            {showOtpLayout ? (
              <View>
                <RenderResetPasswordLayout
                  captchaCodeRef={captchaCodeRef}
                  loading={loading}
                  isKioskMode={isKioskMode}
                  resetPasswordHandler={(
                    values: FormStateReset,
                    setFormData: any,
                    captchaId: string
                  ) => {
                    resetPasswordHandler(values, setFormData, captchaId);
                  }}
                  setShowOtpLayout={setShowOtpLayout}
                  phoneNumber={phoneNumber}
                  resetPasswordTimeLeft={resetPasswordTimeLeft}
                  setResetPasswordTimeLeft={setResetPasswordTimeLeft}
                />
              </View>
            ) : (
              <RenderGetPhoneNumber
                captchaCodeRef={captchaCodeRef}
                loading={loading}
                requestOTP={(
                  values: any,
                  captchaId: string,
                  setFormData: any
                ) => requestOTP(values, captchaId, setFormData)}
              />
            )}
            <ArButton
              variant="ghost"
              onPress={() => navigation.replace("Login")}
            >
              {translate("login.loginHeading")}
            </ArButton>
          </View>
        </Center>
      </KeyboardAvoidingView>
    </LoginLayout>
  );
};

export default ResetPasswordScreen;

// === Render Sign In Layout  ===
const RenderResetPasswordLayout = (props: any) => {
  const [formData, setFormData] = useReducer(
    (state: FormStateReset, action: FormAction): FormStateReset => {
      switch (action.type) {
        case "UPDATE_OTP":
          return {
            ...state,
            otp: action.payLoad,
          };
        case "UPDATE_PASSWORD":
          return {
            ...state,
            password: action.payLoad,
          };
        case "UPDATE_CONFIG_PASSWORD":
          return {
            ...state,
            confirmPassword: action.payLoad,
          };
        case "UPDATE_CAPTCHA_CODE":
          return {
            ...state,
            captchaCode: action.payLoad,
          };
        default:
          return state;
      }
    },
    initialStateReset
  );
  const [formValidityData, setFormValidityData] = useReducer(
    (
      state: FormResetValidityState,
      action: FormValidityActionReset
    ): FormResetValidityState => {
      let isValid: boolean = false;
      let IsRequired: string = "";
      switch (action.type) {
        case "VALIDATE_OTP":
          isValid = action.payLoad.otp.length > 2 ? true : false;
          IsRequired =
            action.payLoad.otp.length == 0
              ? translate("login.errors.EmptyUserName")
              : "";

          return {
            ...state,
            ...{
              otpError: !!IsRequired,
              isFormValid:
                IsRequired == "" &&
                !state.confirmPasswordError &&
                !state.passwordError,
              otpErrorMessageMessage: IsRequired,
            },
          };
        case "VALIDATE_PASSWORD":
          isValid = action.payLoad.password.length > 4 ? true : false;
          IsRequired =
            action.payLoad.password.length == 0
              ? translate("login.errors.requiredPassword")
              : !isValid
              ? translate("login.errors.ShortPassword")
              : !validationPassword(action.payLoad.password)
              ? translate("login.errors.minimumRightCharactersPassword")
              : "";
          return {
            ...state,
            ...{
              passwordError: !isValid,
              isFormValid:
                IsRequired == "" &&
                !state.otpError &&
                !state.confirmPasswordError,
              passwordErrorMessage: IsRequired,
            },
          };
        case "VALIDATE_CONFIRM_PASSWORD":
          isValid = action.payLoad.confirmPassword === action.payLoad.password;
          IsRequired = !isValid
            ? translate("login.errors.DisMatchedPassword")
            : "";
          return {
            ...state,
            ...{
              confirmPasswordError: !isValid,
              isFormValid:
                IsRequired == "" && !state.passwordError && !state.otpError,
              confirmPasswordErrorMessage: IsRequired,
            },
          };
        case "VALIDATE_CAPTCHA_CODE":
          IsRequired = !action.payLoad.captchaCode
            ? translate("login.errors.captchaCodeIsRequired")
            : "";
          return {
            ...state,
            ...{
              captchaCodeError: !!IsRequired,
              isFormValid:
                IsRequired == "" &&
                !state.otpError &&
                !state.passwordError &&
                !state.confirmPasswordError,
              captchaCodeErrorMessage: IsRequired,
            },
          };
        default:
          return state;
      }
    },
    initialValidityStateReset
  );

  let {
    resetPasswordHandler,
    phoneNumber,
    loading,
    setShowOtpLayout,
    setResetPasswordTimeLeft,
    resetPasswordTimeLeft,
    captchaCodeRef,
  } = props;
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);
  const [validCaptchaCode, setValidCaptchaCode] = useState<boolean>(false);
  const [captchaId, setCaptchaId] = useState<string | null>(null);
  return (
    <VStack space="2" mt="2">
      <InputBase
        containerStyle={{ marginBottom: 0 }}
        inputStyle={{ height: INPUT_HEIGHT, fontSize: 12 }}
        showSubInput={true}
        keyboardType="numeric"
        label={translate("login.OtpMessage", { phoneNumber })}
        labelStyle={{ fontSize: 11, marginBottom: 0, padding: 0 }}
        isInvalid={formValidityData.otpError}
        // errorMessage={formValidityData.otpErrorMessage}
        value={formData.otp}
        placeholder={translate("login.otpSms")}
        onChangeText={(otp: string) =>
          setFormData({
            type: "UPDATE_OTP",
            payLoad: otp,
          })
        }
        onBlur={() =>
          setFormValidityData({
            type: "VALIDATE_OTP",
            payLoad: formData,
          })
        }
        icon={faCharCodes.faLockAlt}
      />
      <View style={{ position: "relative", height: 50 }}>
        {resetPasswordTimeLeft > 0 && (
          <CountDown
            until={resetPasswordTimeLeft}
            size={18}
            timeToShow={["M", "S"]}
            style={{
              direction: Platform.OS == "web" ? "rtl" : "ltr",
            }}
            digitStyle={{
              backgroundColor: "#FFFFFF00",
            }}
            onFinish={() => {
              setTimeout(() => {
                setResetPasswordTimeLeft(0);
                setShowOtpLayout(false);
                captchaCodeRef && captchaCodeRef?.current?.refreshCaptcha();
              }, 1000);
            }}
            timeLabelStyle={{ color: Theme.COLORS.MUTED, display: "none" }}
            timeLabels={{
              // d: translate("timer.days"),
              // h: translate("timer.hours"),
              m: " ",
              s: " ",
            }}
            showSeparator
          />
        )}
      </View>
      <View>
        {/* === Password === */}
        <InputBase
          showSubInput={true}
          inputStyle={{ height: INPUT_HEIGHT, fontSize: 12 }}
          label={translate("login.errors.minimumRightCharactersPassword")}
          labelStyle={{ fontSize: 10, padding: 0, marginTop: 10 }}
          isInvalid={formValidityData.passwordError}
          errorMessage={formValidityData.passwordErrorMessage}
          value={formData.password}
          placeholder={translate("login.password")}
          onChangeText={(password: string) =>
            setFormData({
              type: "UPDATE_PASSWORD",
              payLoad: password,
            })
          }
          onBlur={() =>
            setFormValidityData({
              type: "VALIDATE_PASSWORD",
              payLoad: formData,
            })
          }
          secureTextEntry={!showPassword}
          icon={faCharCodes.faLockAlt}
          iconLeft={
            <TouchableWithoutFeedback
              onPress={() => setShowPassword(!showPassword)}
            >
              <View
                style={{
                  justifyContent: "center",
                  alignItems: "center",
                  paddingHorizontal: 14,
                }}
              >
                <FontAwesomeIcon
                  icon={
                    showPassword ? faCharCodes.faEyeSlash : faCharCodes.faEye
                  }
                  color={Theme.COLORS.MUTED}
                />
              </View>
            </TouchableWithoutFeedback>
          }
        />
        {/* === Confirm Password === */}
        <InputBase
          inputStyle={{ height: INPUT_HEIGHT, fontSize: 12 }}
          showSubInput={true}
          isInvalid={formValidityData.confirmPasswordError}
          errorMessage={formValidityData.confirmPasswordErrorMessage}
          value={formData.confirmPassword}
          placeholder={translate("login.confirmPassword")}
          onChangeText={(confirmPassword: string) =>
            setFormData({
              type: "UPDATE_CONFIG_PASSWORD",
              payLoad: confirmPassword,
            })
          }
          onBlur={() =>
            setFormValidityData({
              type: "VALIDATE_CONFIRM_PASSWORD",
              payLoad: formData,
            })
          }
          secureTextEntry={!showPasswordConfirm}
          icon={faCharCodes.faLockAlt}
          iconLeft={
            <TouchableWithoutFeedback
              onPress={() => setShowPasswordConfirm(!showPasswordConfirm)}
            >
              <View
                style={{
                  justifyContent: "center",
                  alignItems: "center",
                  paddingHorizontal: 14,
                }}
              >
                <FontAwesomeIcon
                  icon={
                    showPasswordConfirm
                      ? faCharCodes.faEyeSlash
                      : faCharCodes.faEye
                  }
                  color={Theme.COLORS.MUTED}
                />
              </View>
            </TouchableWithoutFeedback>
          }
        />
      </View>
      {/* === Captcha Code === */}
      <CaptchaCode
        ref={captchaCodeRef}
        setValidCaptchaCode={setValidCaptchaCode}
        setCaptchaId={(captchaId) => {
          setCaptchaId(captchaId);
        }}
        captchaId={captchaId}
        captchaCode={formData.captchaCode}
        setCaptchaCode={(code) => {
          setFormData({ type: "UPDATE_CAPTCHA_CODE", payLoad: code });
        }}
        onBlur={() => {
          setFormValidityData({
            type: "VALIDATE_CAPTCHA_CODE",
            payLoad: formData,
          });
        }}
        errorMessage={formValidityData.captchaCodeErrorMessage}
      />
      {/* === Submit Btn === */}
      <ArButton
        isLoading={loading}
        onPress={() => {
          setFormValidityData({
            type: "VALIDATE_OTP",
            payLoad: formData,
          });
          setFormValidityData({
            type: "VALIDATE_PASSWORD",
            payLoad: formData,
          });
          setFormValidityData({
            type: "VALIDATE_CONFIRM_PASSWORD",
            payLoad: formData,
          });
          validCaptchaCode &&
            setFormValidityData({
              type: "VALIDATE_CAPTCHA_CODE",
              payLoad: formData,
            });
          if (
            formData.otp.length > 2 &&
            formData.password.length > 4 &&
            validationPassword(formData.password) &&
            formData.password === formData.confirmPassword &&
            (validCaptchaCode
              ? formData.captchaCode && formData.captchaCode?.length !== 0
              : true)
          ) {
            formValidityData.isFormValid &&
              resetPasswordHandler(formData, setFormData, captchaId);
          }
        }}
      >
        {translate("login.resetPasswordHeading")}
      </ArButton>
    </VStack>
  );
};

const RenderGetPhoneNumber = (props: any) => {
  let { requestOTP, loading, captchaCodeRef } = props;
  const [captchaId, setCaptchaId] = useState<string | null>(null);
  const [validCaptchaCode, setValidCaptchaCode] = useState<boolean>(false);
  // === Form Validation ===
  const [formData, setFormData] = useReducer(
    (state: FormStatePhoneNumber, action: FormAction): FormStatePhoneNumber => {
      switch (action.type) {
        case "UPDATE_PHONE_NUMBER":
          return {
            ...state,
            phoneNumber: action.payLoad,
          };
        case "UPDATE_CAPTCHA_CODE":
          return {
            ...state,
            captchaCode: action.payLoad,
          };
        default:
          return state;
      }
    },
    initialState
  );
  const [formValidityData, setFormValidityData] = useReducer(
    (
      state: FormValidityState,
      action: FormValidityAction
    ): FormValidityState => {
      let isValid: boolean = false;
      let IsRequired: string = "";
      switch (action.type) {
        case "VALIDATE_PHONE_NUMBER":
          isValid = action.payLoad.phoneNumber.length > 9 ? true : false;
          IsRequired =
            action.payLoad.phoneNumber.length == 0
              ? translate("login.errors.EmptyUserName")
              : !isValid
              ? translate("login.errors.InvalidPhoneNumber")
              : "";
          return {
            ...state,
            ...{
              phoneNumberError: !isValid,
              isFormValid: IsRequired == "" && !state.captchaCodeError,
              phoneNumberErrorMessage: IsRequired,
            },
          };
        case "VALIDATE_CAPTCHA_CODE":
          IsRequired = !action.payLoad.captchaCode
            ? translate("login.errors.captchaCodeIsRequired")
            : "";
          return {
            ...state,
            ...{
              captchaCodeError: !!IsRequired,
              isFormValid: IsRequired == "" && !state.phoneNumberError,
              captchaCodeErrorMessage: IsRequired,
            },
          };
        default:
          return state;
      }
    },
    initialValidityState
  );
  return (
    <>
      {/* === Phone Number === */}
      <InputBase
        inputStyle={{ height: INPUT_HEIGHT, fontSize: 12 }}
        showSubInput={true}
        keyboardType="numeric"
        isInvalid={formValidityData.phoneNumberError}
        errorMessage={formValidityData.phoneNumberErrorMessage}
        placeholder={translate("login.phoneNumber")}
        value={formData.phoneNumber}
        onChangeText={(phoneNumber: string) =>
          setFormData({
            type: "UPDATE_PHONE_NUMBER",
            payLoad: phoneNumber,
          })
        }
        onBlur={() =>
          setFormValidityData({
            type: "VALIDATE_PHONE_NUMBER",
            payLoad: formData,
          })
        }
        icon={faCharCodes.faPhoneAlt}
      />
      {/* === Captcha Code === */}
      <CaptchaCode
        ref={captchaCodeRef}
        setValidCaptchaCode={setValidCaptchaCode}
        setCaptchaId={(captchaId) => {
          setCaptchaId(captchaId);
        }}
        captchaId={captchaId}
        captchaCode={formData.captchaCode}
        setCaptchaCode={(code) => {
          setFormData({ type: "UPDATE_CAPTCHA_CODE", payLoad: code });
        }}
        onBlur={() => {
          setFormValidityData({
            type: "VALIDATE_CAPTCHA_CODE",
            payLoad: formData,
          });
        }}
        errorMessage={formValidityData.captchaCodeErrorMessage}
      />
      {/* === Submit Btn === */}
      <ArButton
        style={{ marginTop: 15 }}
        isLoading={loading}
        onPress={() => {
          setFormValidityData({
            type: "VALIDATE_PHONE_NUMBER",
            payLoad: formData,
          });
          validCaptchaCode &&
            setFormValidityData({
              type: "VALIDATE_CAPTCHA_CODE",
              payLoad: formData,
            });
          if (
            formData.phoneNumber.length > 9 &&
            (validCaptchaCode
              ? formData.captchaCode && formData.captchaCode?.length !== 0
              : true)
          ) {
            formValidityData.isFormValid &&
              requestOTP(formData, captchaId, setFormData);
          }
        }}
      >
        {translate("login.sendOTP")}
      </ArButton>
    </>
  );
};
